import { Grid, GridItem } from '@truepill/react-capsule'
import { PageContent } from 'components/PageStructure'
import PV1MedicationCard from 'components/PV1MedicationCard'
import { PV1PatientCard } from 'components/PV1PatientCard'
import { PV1PrescriberCard } from 'components/PV1PrescriberCard'
import RxHeadingV2 from 'components/RxHeadingV2'
import { SideToolBar } from 'components/SideToolBar/SideToolBar'
import type { Fill, Log, Order, Patient, Prescription, RXFillRequest, TPOSDocument } from 'types'

type PV1ViewProps = {
  patient: Patient
  rxFillRequest: RXFillRequest
  prescription: Prescription
  order: Order
  fill: Fill
  logs: Log[]
  showNotesBadge: boolean
  docs: TPOSDocument[]
}

const PV1ViewV2 = ({
  patient,
  rxFillRequest,
  prescription,
  order,
  fill,
  logs,
  showNotesBadge,
  docs,
}: PV1ViewProps): JSX.Element => {
  if (!order || !fill || !prescription || !patient) {
    return <></>
  }

  return (
    <>
      <RxHeadingV2 fill={fill} order={order} prescription={prescription} />

      <PageContent style={{ gap: '16px', paddingRight: '1.875rem' }}>
        <Grid css={{ width: '100%' }}>
          <GridItem desktop={6} tablet={4}>
            <Grid>
              <GridItem desktop={12} tablet={8}>
                <PV1PatientCard patient={patient} prescription={prescription} />
              </GridItem>

              <GridItem desktop={12} tablet={8}>
                <PV1PrescriberCard prescription={prescription} />
              </GridItem>
            </Grid>
          </GridItem>

          <GridItem desktop={6} tablet={4}>
            <PV1MedicationCard prescription={prescription} fill={fill} rxFillRequest={rxFillRequest} />
          </GridItem>
        </Grid>

        <SideToolBar
          order={order}
          fill={fill}
          prescription={prescription}
          patient={patient}
          logs={logs}
          showNotesBadge={showNotesBadge}
          docs={docs}
        />
      </PageContent>
    </>
  )
}

export default PV1ViewV2
